/* eslint-disable react-hooks-ssr/react-hooks-global-ssr */
export function canUseDOM() {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}